import Box from '@mui/material/Box';
import React, {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import {constance} from '../common/constance/constance';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Swal from 'sweetalert2';
import {commonReducer} from '../reducer/common';
import {useDispatch} from 'react-redux';
import {config} from '../common/config/config';
import {useNavigate} from 'react-router-dom';
import ResetPasswordDialog from "./dialog/ResetPasswordDialog";

const sha256 = require('sha256');

export default function Login() {
    const [state, setState] = useState({
        id: '',
        pw: '',
        openResetPassword: false,
    });
    useEffect(() => {
        console.log('%c[Login]', 'color: yellow');
    }, []);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const bottomBoxRef: any = useRef();

    function handleLogIn(e: any) {
        if (e._reactName === 'onClick' || e.keyCode === 13) {
            if (state.id == '') {
                Swal.fire({
                    title: '',
                    text: '아이디를 입력주세요.',
                    icon: 'warning',
                    confirmButtonColor: '#468cf4',
                });
                return;
            } else if (state.pw == '') {
                Swal.fire({
                    title: '',
                    text: '비밀번호를 입력주세요.',
                    icon: 'warning',
                    confirmButtonColor: '#468cf4',
                });
                return;
            }

            axios.post(constance.api.logIn, {
                id: state.id,
                pw: sha256(state.pw),
            }).then(value => {
                if (value.data.data == null) {
                    Swal.fire({
                        title: '',
                        text: '아이디 또는 비밀번호를 확인하여 주세요.',
                        icon: 'warning',
                        confirmButtonColor: '#468cf4',
                    });
                } else {
                    dispatch(commonReducer.setUser(value.data.data));
                    navigate('/');
                }
            });
        }
    }


    // 패스워드 리셋
    function handleOpenResetPassword(e: any) {
        setState({
            ...state,
            openResetPassword: true
        })
    }

    function handleChangeValue(e: any, key: string) {
        setState({
            ...state,
            [key]: e.target.value,
        });
    }


    function handleHideShowBottomBox(isShow: boolean) {
        if (window.innerHeight < 500) {
            bottomBoxRef.current.style.display = isShow ? 'flex' : 'none';
        }
    }

    return (
        <>
            <ResetPasswordDialog state={state} setState={setState}/>
            <Box sx={{
                display: 'flex',
                width: 1,
                height: 1,
                position: 'relative',
            }}>
                <Box sx={{
                    width: 1,
                    height: 1,
                    position: 'absolute',
                    backgroundImage: `url(/images/logIn.jpg)`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: {xs: 'cover', sm: 'cover', md: 'cover'},
                }}>

                </Box>
                <Box sx={{
                    width: {xs: 1, sm: 1, md: 450},
                    height: 1,
                    position: 'absolute',
                    left: {xs: 0, sm: 0, md: `calc(100vw - 800px)`},
                }}>
                    <Stack sx={{
                        display: 'flex',
                        width: 1,
                        height: 1,
                        backgroundColor: '#1a1a1a80',
                    }}>
                        {/* 상단 로고 박스 */}
                        <Box sx={{
                            mt: 10,
                            width: 1,
                            height: 200,
                            backgroundColor: '#1a1a1aa6',
                            display: 'flex',
                            justifyContent: 'center',
                            position: 'relative',
                        }}>
                            <img src={`/images/logInLogo.png`}
                                 style={{height: '120%', position: 'absolute', top: '-20px'}}/>
                        </Box>

                        {/* 하단 입력 박스 */}
                        <Stack sx={{
                            position: 'relative',
                            display: 'flex',
                            p: 3,
                            flexGrow: 1,
                            justifyContent: 'center',
                            width: 1,
                            pt: {xs: 0, sm: 0, md: 10},
                        }}>
                            <Box sx={{
                                width: 1, flexGrow: 1,
                                justifyContent: 'center',
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <Typography variant={'h4'}
                                            sx={{color: '#fff'}}> Welcome! </Typography>
                                <Typography variant={'h6'}
                                            sx={{color: '#fff'}}> A better tomorrow than today </Typography>
                                <TextField variant="filled"
                                           label="사원번호"
                                           value={state.id}
                                           onChange={(e) => handleChangeValue(e, 'id')}
                                           sx={{backgroundColor: 'var(--scc-surface)', mt: 2, width: 1, borderRadius: 1}}/>
                                <TextField variant="filled"
                                           label="비밀번호"
                                           value={state.pw}
                                           onChange={(e) => handleChangeValue(e, 'pw')}
                                           type="password"
                                           onKeyDown={(e) => handleLogIn(e)}
                                           sx={{backgroundColor: 'var(--scc-surface)', mt: 1, width: 1, borderRadius: 1}}/>
                                <Box sx={{display: 'flex', mt: 1, mb: 1}}>
                                    <Button variant={'contained'}
                                            size="large"
                                            onClick={(e) => handleLogIn(e)}
                                            sx={{width: 1}}><Typography>{'로그인'}</Typography>
                                    </Button>
                                </Box>
                                <Box sx={{display: 'flex', mt: 0, mb: 1}}>
                                    <Button variant={'contained'}
                                            size={"large"}
                                            color={"error"}
                                            onClick={(e) => handleOpenResetPassword(e)}
                                            sx={{width: 1}}><Typography>{'비밀번호 초기화'}</Typography>
                                    </Button>
                                </Box>
                            </Box>

                            <Box ref={bottomBoxRef}
                                 sx={{
                                     // position: 'absolute',
                                     // bottom: 24,
                                     width: 1,
                                     display: 'flex',
                                     alignItems: 'center', color: 'white', fontWeight: 'bold',
                                 }}>
                                <Stack sx={{width: 0.5, alignItems: 'center'}}>
                                    <Typography> {'계정문의, 기술지원'}</Typography>
                                    <Typography sx={{mt: 1}}> {'IT개발팀 221 ~ 223'}</Typography>
                                </Stack>
                                <Divider orientation={'vertical'} sx={{borderColor: 'white'}}/>
                                <Stack sx={{width: 0.5, alignItems: 'center'}}>
                                    <img src={'/images/sib_logo.jpg'}
                                         style={{height: '40px'}}
                                         alt={'SIB LOGO'}/>
                                    <Typography sx={{mt: 1}}>{'WE MAKE DIFFERENCE'}</Typography>
                                </Stack>
                            </Box>
                        </Stack>
                    </Stack>
                </Box>

            </Box>
        </>

    );
}
